import get from 'lodash/get';
import omit from 'lodash/omit';
// Possibly should use Proxy instead of events?

// Setup an action by setting an object with optional arguments and callback to the path that the function will be in window.FS
// path the function will be and call window.dispatchEvent(new Event('fsActionAdded'));

// e.g
//              window.FS.ACTIONS.JOURNEY_AWARENESS = window.FS.ACTIONS.JOURNEY_AWARENESS || {};
// 				window.FS.ACTIONS.JOURNEY_AWARENESS.moveQuickLinksFromHeroToBody = {
// 					arguments: {
// 						ensureBodySectionTopSpacing: true,
// 					},
// 					callback: () => {
// 						//move the Featured Offers

// 						}
// 					},
// 				};

//To make sure it happens call window.dispatchEvent(new Event('fsActionReady'));
//after you add the function

// e.g
// window.FS.JOURNEY_AWARENESS.moveQuickLinksFromHeroToBody = moveQuickLinksFromHeroToBody;
// window.dispatchEvent(new Event('fsActionReady'));
const handleActionsAtPath = async (actions = {}, path = '') => {
	// Iterate over keys in `actions` object
	Object.keys(actions).forEach(async key => {
		const val = actions[key];
		// Get value from `window.FS` using `path` and `key`
		const fsVal = get(window.FS, path + key);
		if (fsVal && typeof fsVal === 'function') {
			// Remove key from `window.FS.ACTIONS`
			window.FS.ACTIONS = omit(window.FS.ACTIONS, path + key);
			actions[key] = undefined;
			// Call `fsVal` function with `val.arguments` as argument
			await fsVal(val?.arguments);
			if (val?.callback) {
				await val.callback();
			}
		} else if (fsVal) {
			// Recursively call `handleActionsAtPath` with modified `path`
			handleActionsAtPath(val, path + key + '.');
		}
	});
};
let queuedCalls = 1;
const handleActions = async () => {
	// Initialize `window.FS` and `window.FS.ACTIONS` if not defined
	window.FS = window.FS || {};
	window.FS.ACTIONS = window.FS.ACTIONS || {};
	// Call `handleActionsAtPath` with `window.FS.ACTIONS` as argument
	await handleActionsAtPath({ ...window.FS.ACTIONS });
};
const runQueuedCalls = async () => {
	while (queuedCalls > 0) {
		queuedCalls--;
		await handleActions();
	}
	requestAnimationFrame(runQueuedCalls);
};
export default async function actionsHandler() {
	// Add event listeners and call `handleActions` function
	window.addEventListener('fsActionReady', () => queuedCalls++);
	window.addEventListener('fsActionAdded', () => queuedCalls++);
	runQueuedCalls();
}
